import Resx from '@/components/Resx'
import { Link } from 'react-router-dom'
import React from 'react'
import { Card } from '@/components/cards/card'

function TicketRestartedWarning ({ restartedAsTicketId }) {
  return restartedAsTicketId ? <Card bgColor='danger' textColor='white' headerText='Common.TicketRestartedHeader'>
    <Resx name='Common.TicketRestartedBody' /><br />
    <Link to={`/tickets/${restartedAsTicketId}`} className='btn btn-primary'><Resx name='Common.GoToNewTicket' /></Link>
  </Card> : null
}

export { TicketRestartedWarning }



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/ticketRestartedWarning.js